(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 93027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return __webpack_require__(925);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86979);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);



var TermsPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Lightsats⚡ - Privacy Policy"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: "Privacy Policy"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                css: {
                    whiteSpace: "pre-line"
                },
                dangerouslySetInnerHTML: {
                    __html: "\n<b>Last updated: February 25, 2025</b>\n\nThis Privacy Policy explains how Lightsats collects, stores, and uses user data.\n\n<b>Data Collection</b>\n\nWe collect minimal user data, which includes:\n- Public key (from LNURL-Auth)\n- Phone number (for SMS login)\n- Email (for authentication via email)\n- We do not collect IP addresses, device information, or analytics.\n\n<b>Purpose of Data Collection</b>\n\nWe collect this data strictly for authentication purposes.\n\nAdditionally, for Tippees, we track their onboarding process, including:\n- When they first see their Bitcoin gift\n- When they authenticate\n- Their progress through onboarding steps\n- When they withdraw their Bitcoin\n\n<b>Data Storage & Retention</b>\n\nData is stored securely on fly.io.\nUser data is retained until a deletion request is received.\n\n<b>Data Sharing</b>\n\nSMS authentication: Phone numbers are shared with SMS4Sats, which relays messages through Twilio.\nEmail authentication: Email addresses are shared with ZohoMail for sending authentication magic links.\nWe do not share data with any other third parties.\nWe will not disclose user data if requested by law enforcement.\n\n<b>User Rights & Control</b>\n\nUsers can request data deletion by contacting support@lightsats.com.\nUsers cannot download their own data directly, but they may request a data export by contacting support@lightsats.com.\n\n<b>Cookies & Tracking</b>\n\nWe do not use cookies or any tracking tools.\n\n<b>Changes to the Privacy Policy</b>\n\nWe may update this Privacy Policy from time to time. Any changes will be posted here, and continued use of Lightsats constitutes acceptance of the updated policy.\n\nFor any privacy-related questions, please contact support@lightsats.com."
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TermsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(93027); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);